import { useEffect, useMemo, useState } from "react";

const PHRASES = [
  "Loading data…",
  "Fetching the latest numbers…",
  "Crunching the data…",
  "Preparing your dashboard…",
  "Almost there…",
];

function shuffle<T>(arr: T[]): T[] {
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = a[i]!;
    a[i] = a[j]!;
    a[j] = tmp;
  }
  return a;
}

export function LoadingPanel({ intervalMs = 2500 }: { intervalMs?: number }) {
  const order = useMemo(() => [PHRASES[0], ...shuffle(PHRASES.slice(1))], []);
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const fadeOut = setInterval(() => {
      setVisible(false);
      const t = setTimeout(() => {
        setIdx((i) => (i + 1) % order.length);
        setVisible(true);
      }, 250);
      return () => clearTimeout(t);
    }, intervalMs);
    return () => clearInterval(fadeOut);
  }, [intervalMs, order.length]);

  return (
    <div style={{ padding: "10px 0" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <img
          src="/marloo-orb-brand-4blobs.svg"
          alt=""
          width={28}
          height={28}
          style={{ flex: "0 0 auto", borderRadius: "50%" }}
        />
        <span
          style={{
            fontSize: 13,
            color: "var(--fg-3)",
            opacity: visible ? 1 : 0,
            transition: "opacity 250ms ease",
          }}
        >
          {order[idx]}
        </span>
      </div>
    </div>
  );
}
